import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'
import LoadingSpinner from '../components/LoadingSpinner'

const AuthCallback = () => {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { setAuth } = useAuthStore()

  useEffect(() => {
    const token = searchParams.get('token')
    const error = searchParams.get('error')

    if (error) {
      console.error('OAuth error:', error)
      navigate('/login?error=' + encodeURIComponent(error))
      return
    }

    if (token) {
      // Decode user data from token (you might want to verify this on the backend)
      try {
        const tokenPayload = JSON.parse(atob(token.split('.')[1]))
        
        // Set the token and fetch user data
        setAuth(null, token)
        
        // Redirect to chat
        navigate('/chat')
      } catch (error) {
        console.error('Token parsing error:', error)
        navigate('/login?error=invalid_token')
      }
    } else {
      navigate('/login?error=no_token')
    }
  }, [searchParams, navigate, setAuth])

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="text-center">
        <LoadingSpinner size="lg" />
        <p className="mt-4 text-gray-600 dark:text-gray-400">
          Completing authentication...
        </p>
      </div>
    </div>
  )
}

export default AuthCallback